export default __webpack_public_path__ + "static/media/ButtonLoadingIcon.b8fe6a2d.svg";